import {defineSlotRecipe} from '@chakra-ui/react3'

export const ugcCarouselRecipe = defineSlotRecipe({
    slots: [
        'moduleContainer',
        'headerContainer',
        'headingCopyContainer',
        'ctaContainer',
        'sliderContainer',
        'tile',
        'tag'
    ],
    base: {
        moduleContainer: {display: 'flex', flexDirection: 'column', align: 'start'},
        headerContainer: {
            justifyContent: 'space-between',
            flexDirection: {base: 'column', s: 'revert'},
            gap: {base: 'spacing-32', s: 'spacing-80'}
        },
        headingCopyContainer: {
            gap: 'spacing-16',
            flexDirection: 'column',
            flex: 1,
            textAlign: {base: 'left', s: 'center'},
            maxWidth: {s: '38.875rem'}
        },
        ctaContainer: {alignContent: 'flex-end'},
        sliderContainer: {paddingTop: {base: 'spacing-40', s: 'spacing-80'}},
        tile: {
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 'm',
            '& video': {width: '100%', height: '100%', objectFit: 'cover'},
            '& > [role="group"]': {gap: '0'}
        },
        tag: {
            position: 'absolute',
            left: 'spacing-16',
            bottom: 'spacing-16',
            display: 'inline-flex',
            alignItems: 'center',
            flexDirection: 'row',
            gap: 'spacing-6',
            paddingLeft: 'spacing-12',
            paddingRight: 'spacing-16',
            paddingY: 'spacing-8',
            borderRadius: 'round',
            background:
                'linear-gradient(0deg, {colors.background.actions.on-media.ghost}, {colors.background.actions.on-media.ghost})',
            backdropFilter: 'blur(4px)',
            color: 'text.on-media.primary',
            textStyle: 'heading.small',
            pointerEvents: 'none',
            '& svg': {width: '5', height: '5'}
        }
    },
    variants: {
        alignment: {
            center: {
                headerContainer: {
                    flexDirection: 'column',
                    justifyContent: 'start',
                    align: 'center',
                    gap: 'spacing-32'
                }
            }
        }
    },
    defaultVariants: {alignment: 'left'}
})
